/**
 * Configuração de navegação do sidebar/drawer.
 * Cada item tem: to, label, icon (Component), testid, e opcionalmente
 * `perm` (chave de permissão que o backend retorna em /permissions/me) ou
 * `adminOnly` (só admin real vê).
 */
import {
  ChartBar,
  Package,
  Kanban,
  Television,
  Stack,
  Users,
  Gear,
  Tag,
  UserList,
  Palette,
  FolderOpen,
  PaintBrush,
  DeviceMobile,
  ClipboardText,
  ArrowsDownUp,
  CurrencyCircleDollar,
  Wallet,
  Desktop,
  CloudArrowUp,
  Receipt,
  ClockCounterClockwise,
  ChartLine,
  ChartPieSlice,
  TrendUp,
} from "@phosphor-icons/react";

export const PRIMARY_NAV = [
  { to: "/", label: "Dashboard", icon: ChartBar, testid: "nav-dashboard", perm: "dashboard" },
];

// CADASTROS aparece logo depois de Dashboard, ANTES de Pedidos
export const CADASTROS_NAV = [
  { to: "/products", label: "Produtos", icon: Tag, testid: "nav-products", perm: "products" },
  { to: "/customers", label: "Clientes", icon: UserList, testid: "nav-customers", perm: "customers" },
  { to: "/cadastros/cup-colors", label: "Cores de Copos", icon: Palette, testid: "nav-cup-colors", perm: "cup_colors" },
  { to: "/cadastros/silk-colors", label: "Cores do Silk", icon: PaintBrush, testid: "nav-silk-colors", perm: "silk_colors" },
];

// Bloco operacional que vem DEPOIS de Cadastros
export const OPERATIONAL_NAV = [
  { to: "/orders", label: "Pedidos", icon: Package, testid: "nav-orders", perm: "orders" },
  { to: "/kanban", label: "Fluxo de Produção", icon: Kanban, testid: "nav-kanban", perm: "kanban" },
  { to: "/painel", label: "Painel Fábrica", icon: DeviceMobile, testid: "nav-panel", perm: "factory_panel" },
  { to: "/estoque/movimentacao", label: "Entrada/Saída Estoque", icon: ArrowsDownUp, testid: "nav-stock-movement", perm: "stock_movement" },
  { to: "/queue", label: "Fila Serigrafia", icon: Television, testid: "nav-queue", perm: "queue" },
  { to: "/inventory", label: "Inventário", icon: Stack, testid: "nav-inventory", perm: "inventory" },
];

// RELATÓRIOS — submenu (Relatório de Produção + Central de Produção BI)
export const REPORTS_NAV = [
  { to: "/relatorios", label: "Relatório de Produção", icon: ClipboardText, testid: "nav-reports", perm: "reports" },
  { to: "/relatorios/central-producao", label: "Central de Produção", icon: ChartPieSlice, testid: "nav-production-center", perm: "production_reports" },
  { to: "/relatorios/vendas", label: "Painel de Vendas", icon: TrendUp, testid: "nav-sales-bi", perm: "sales_bi" },
];

export const FINANCE_NAV = [
  { to: "/financeiro/contas-a-pagar", label: "Contas a Pagar", icon: CurrencyCircleDollar, testid: "nav-bills", perm: "finance" },
  { to: "/financeiro/folha", label: "Folha de Pagamento", icon: Wallet, testid: "nav-payroll", perm: "payroll" },
];

// FISCAL — submenu de NF-e (Emissão, Histórico, Relatório, Config)
export const FISCAL_NAV = [
  { to: "/fiscal/emit",    label: "Emissão",          icon: Receipt,               testid: "nav-fiscal-emit",    perm: "fiscal" },
  { to: "/fiscal/history", label: "Histórico",        icon: ClockCounterClockwise, testid: "nav-fiscal-history", perm: "fiscal" },
  { to: "/fiscal/report",  label: "Relatório Mensal", icon: ChartLine,             testid: "nav-fiscal-report",  perm: "fiscal" },
  { to: "/fiscal/config",  label: "Configurações",    icon: Gear,                  testid: "nav-fiscal-config",  perm: "fiscal" },
];

// ADMIN direto (sem submenu) — só admin real vê
export const ADMIN_NAV = [
  { to: "/collaborators", label: "Colaboradores", icon: Users, testid: "nav-collaborators" },
  { to: "/configuracoes/logins", label: "Logins de Estação", icon: Desktop, testid: "nav-station-logins" },
  { to: "/auditoria/apontamentos", label: "Log de Apontamentos", icon: ClipboardText, testid: "nav-audit" },
];

// Sub-menu CONFIGURAÇÕES (Bling + Backup)
export const SETTINGS_NAV = [
  { to: "/settings/bling", label: "Bling", icon: Gear, testid: "nav-bling", adminOnly: true },
  { to: "/backup", label: "Backup", icon: CloudArrowUp, testid: "nav-backup", perm: "backup" },
];

export const FINANCE_GROUP_ICON = CurrencyCircleDollar;
export const CADASTROS_GROUP_ICON = FolderOpen;
export const SETTINGS_GROUP_ICON = Gear;
export const FISCAL_GROUP_ICON = Receipt;
export const REPORTS_GROUP_ICON = ChartLine;
